<template>
  <div class="row">
    <div class="col-md-9">
      <div class="box box-solid">
        <div class="box-body">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>No</th>
                <th class="col-md-8">Sasaran Penilaian</th>
                <th class="col-md-4" colspan="5">Opsi Nilai</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(indicator, i) in indicators">
                <td>{{ i + 1 }}</td>
                <td>{{ indicator.description }}</td>
                <td
                  v-for="item in indicator.options"
                  class="text-center"
                >
                  <button
                    @click="indicator.value = item"
                    :class="{
                      'btn-default': item != indicator.value,
                      'btn-info': item == indicator.value,
                    }"
                    class="btn">{{ item }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <rentang-penilaian/>
    </div>
    <div class="col-md-3">
      <div class="box box-solid">
        <div class="box-body">
          <table class="table">
            <tr>
              <td class="lead"><strong>Nilai Ujian</strong></td>
              <td class="lead text-right"><strong>{{ sum() }}</strong></td>
            </tr>
            <tr v-if="this.updated_at">
              <td><i>Tanggal Penilaian</i></td>
              <td class="text-right"><i>{{ this.updated_at }}</i></td>
            </tr>
          </table>
          <p></p>
          <p>
            <strong>Penilai</strong><br>
            {{ assessor }}
          </p>
        </div>
      </div>
      <button
        @click="save()"
        class="btn btn-primary">Simpan</button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import RentangPenilaian from './RentangPenilaian'

export default {
  components: {
    RentangPenilaian,
  },
  props: ['proposal_id', 'assessor', 'score', 'jenjang', 'updated_at'],
  data: () => ({
    s1: [
      {
        description: 'Kemampuan menyusun proposal',
        options: [2, 4, 6, 8, 10],
        value: null,
      },
      {
        description: 'Kebenaran ide',
        options: [4, 8, 12, 18, 20],
        value: null,
      },
      {
        description: 'Kemampuan menjelaskan ide',
        options: [3, 6, 9, 12, 15],
        value: null,
      },
      {
        description: 'Kemampuan mempertahankan ide',
        options: [4, 8, 12, 18, 20],
        value: null,
      },
      {
        description: 'Objektifitas dalam menanggapi pertanyaan',
        options: [2, 6, 9, 12, 15],
        value: null,
      },
      {
        description: 'Persiapan untuk presentasi',
        options: [2, 4, 6, 9, 10],
        value: null,
      },
      {
        description: 'Sikap dan penampilan',
        options: [2, 4, 6, 8, 10],
        value: null,
      }
    ],
    s2: [
      {
        description: 'Kemampuan menyusun makalah',
        options: [2, 4, 6, 8, 10],
        value: null,
      },
      {
        description: 'Kebenaran ide',
        options: [4, 8, 12, 18, 20],
        value: null,
      },
      {
        description: 'Kemampuan menjelaskan ide',
        options: [3, 6, 9, 13, 15],
        value: null,
      },
      {
        description: 'Kemampuan mempertahankan ide',
        options: [4, 8, 12, 18, 20],
        value: null,
      },
      {
        description: 'Objektifitas dalam menanggapi pertanyaan',
        options: [2, 6, 9, 12, 15],
        value: null,
      },
      {
        description: 'Persiapan untuk presentasi',
        options: [2, 4, 6, 8, 10],
        value: null,
      },
      {
        description: 'Sikap dan penampilan',
        options: [2, 4, 6, 8, 10],
        value: null,
      }
    ],
    indicators: [],
  }),
  methods: {
    sum() {
      let sum = 0
      for (var i = this.indicators.length - 1; i >= 0; i--) {
        sum += this.indicators[i].value
      }
      if (this.score != 0 && sum == 0) {
        sum = this.score
      }
      return sum
    },
    async save() {
      let sum = this.sum()
      await axios.post('/proposal/penilaian/' + this.proposal_id, {
        nilai: sum
      })
      window.$.notify({
        // options
        message: 'Nilai berhasil disimpan.'
      },{
        // settings
        type: 'success',
        delay: 1250,
        placement: {
          from: "top",
          align: "center"
        },
      });
    },
  },
  created() {
    this.indicators = this[this.jenjang]
  },
}
</script>